import { Save } from 'lucide-react';
import { Button } from '@/components/shadcn/button';

type Props = {
  onBack: () => void;
  onNext: () => void;
  onSaveExit?: () => void;
  disableBack?: boolean;
  disableNext?: boolean;
  nextButtonLabel?: string;
};

export default function FormActions({ onBack, onNext, onSaveExit, disableBack, disableNext, nextButtonLabel = 'Next' }: Props) {
  return (
    <footer className='shrink-0 bg-white border-t border-gray-300  py-4'>
      <div className='w-full max-w-5xl mx-auto px-6'>
        <div className='flex justify-between'>
          <Button
            type='button'
            className='bg-gray-50 text-black border border-gray-200 hover:bg-gray-100'
            onClick={onBack}
            disabled={disableBack}
          >
            Back
          </Button>

          <Button
            type='button'
            variant='ghost'
            className='bg-gray-100 border text-black hover:bg-gray-200 hover:text-black'
            onClick={onSaveExit}
          >
            <Save />
            <span className='ml-2 hidden sm:inline'>Save and Exit</span>
          </Button>

          <Button type='button' className='bg-green-600 hover:bg-green-700 hover:text-white' onClick={onNext} disabled={disableNext}>
            {nextButtonLabel}
          </Button>
        </div>
      </div>
    </footer>
  );
}
